import React from "react";
import { HeadingOne } from "../typography";
import SupportBlock from "../info/SupportBlock";

/**
 * Map-style rings and a drawn check — no Lottie, no white plate.
 */
const AuthSuccessMark = () => (
  <div className="auth-success-mark" aria-hidden="true">
    <span className="auth-success-ring auth-success-ring--a" />
    <span className="auth-success-ring auth-success-ring--b" />
    <span className="auth-success-orbit">
      <span className="auth-success-pin" />
    </span>
    <span className="auth-success-orbit auth-success-orbit--slow">
      <span className="auth-success-pin auth-success-pin--far" />
    </span>
    <div className="auth-success-badge-wrap">
      <svg className="auth-success-badge" viewBox="0 0 88 88">
        <circle className="auth-success-disc" cx="44" cy="44" r="36" />
        <path className="auth-success-check" d="M28 45.5 L38.5 56 L61 32" />
      </svg>
    </div>
  </div>
);

/**
 * Transparent success wait screen over the branded route scene.
 * @param {{ title: string, subtitle: string, area: string }} props
 */
const AuthSuccessScene = ({ title, subtitle, area }) => (
  <div className="auth-success">
    <AuthSuccessMark />
    <HeadingOne className="text-[#003eb2] text-center text-2xl font-semibold mb-2">
      {title}
    </HeadingOne>
    <p className="text-center mb-0 text-sm text-slate-600 font-poppins max-w-xs">
      {subtitle}
    </p>
    <div className="auth-success-wait" aria-hidden="true">
      <span />
      <span />
      <span />
    </div>
    <SupportBlock area={area} tailwindProps="mt-10" />
  </div>
);

export default AuthSuccessScene;
